import React, { useEffect, useState } from 'react'
import Modal from '../../components/UI/Modal/Modal';
import { API_ENDPOINT, API_URL } from '../../api/constant';
import { useSelector } from 'react-redux';
import { IRole } from '../../interfaces/user';
import { callApi } from '../../api/callApi';
import { showToastNotification } from '../../utility/helper';

interface assignDriverModalInterface {
    modal: boolean,
    selectedOrders: string[],
    close: () => void
}

const AssignDriverModal: React.FC<assignDriverModalInterface> = ({ modal, selectedOrders, close }) => {
    const roles: IRole[] = useSelector((state: any) => state.root.roles)
    const [drivers, setDrivers] = useState<any[]>([]);
    const [driversLoading, setDriversLoading] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState<string>("");
    useEffect(() => {
        if (modal) {
            getDrivers();
        }
    }, [modal]);

    // Update your getDrivers function
    const getDrivers = async (page: number = 1) => {
        try {
            setDriversLoading(true);
            let roleId = roles.find((role: IRole) => role.name.toLowerCase().includes('driver'))?.id || '';
            const response = await callApi(API_URL + API_ENDPOINT.auth + `user/list?page=${page}&sortType=DESC&roleId=${roleId}&isOnRide=false`, { method: 'GET' });
            setDrivers(response.data);
        } catch (error: any) {
            console.error('Failed to fetch drivers:', error.message);
        } finally {
            setDriversLoading(false);
        }
    };



    const handleAssignOrder = async () => {
        for (let index = 0; index < selectedOrders.length; index++) {
            const element = selectedOrders[index];
            assignOrder(element, index + 1 === selectedOrders.length)

        }
    }

    const assignOrder = async (orderId: string, isLastIndex: boolean) => {
        let payload = {
            "id": orderId,
            "driverId": selectedDriver
        }
        try {
            await callApi(API_URL + API_ENDPOINT.order + `orders/assign-driver`, { method: 'PUT', data: payload });
            if (isLastIndex) {
                showToastNotification('success', 'Order Assign Successfully');
                close()
            }
        } catch (error: any) {
            showToastNotification('danger', error?.message || 'Failed to assign order');
            console.error('Failed to fetch drivers:', error.message);
        } finally {
            setDriversLoading(false);
        }
    }
    return (
        <Modal
            show={modal}
            onClose={() => {
                close();
                setSelectedDriver("");
            }}
            title={`Allocate Order to Driver`}
        >
            {driversLoading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    <div className="mb-3">
                        <label className="form-label">Select Driver</label>
                        <select
                            className="form-select"
                            value={selectedDriver}
                            onChange={(e) => setSelectedDriver(e.target.value)}
                        >
                            <option value="">Choose Driver</option>
                            {drivers.map(driver => (
                                <option key={driver.id} value={driver.id}>
                                    {driver.fullName} - {driver.phone}
                                </option>
                            ))}
                        </select>
                    </div>
                    <button
                        className="btn btn-primary w-100"
                        disabled={!selectedDriver}
                        onClick={() => handleAssignOrder()}
                    >
                        {selectedDriver
                            ? 'Assign the Order to the Driver'
                            : 'Select Driver First'}
                    </button>
                </>
            )}
        </Modal>
    )
}

export default AssignDriverModal